import { HOST_API } from 'config';
export const LOGIN_API = HOST_API + '/user/login';
export const REGISTER_API = HOST_API + '/user/create';
export const VERIFY_EMAIL_TOKEN = HOST_API + '/user/verifyuser/';
export const USER_DETAILS_API_URL = HOST_API + '/user/getDetails';
export const FORGOT_PASSWORD_API_URL = HOST_API + '/user/forgot';
export const FORGOT_RESET_PASSWORD_API_URL = HOST_API + '/user/forgotreset';
export const RESET_ONBOARDING_PASSWORD =
  HOST_API + '/formpayhome/onboarding/resetOnboardingPassword';
export const UPDATE_PROFILE_API_URL = HOST_API + '/user/updateProfile';
export const RESET_PASSWORD_API_URL = HOST_API + '/user/resetpassword';
export const RESEND_VERIFICATION_MAIL_URL =
  HOST_API + '/user/resendConfirmation';
export const CONNECT_TO_HUBSPOT_API_URL =
  HOST_API + '/connector/get/installationForm';
export const PORTAL_LISTING_API_URL =
  HOST_API + '/formpayhome/portal/getAllPortals';
export const GATEWAY_LISTING_API_URL =
  HOST_API + '/formpayhome/gateway/getUserGateways';
export const GATEWAY_DETAIL_API_URL =
  HOST_API + '/formpayhome/gateway/getUserGatewayDetails';
export const SAVE_USER_GATEWAY_API_URL =
  HOST_API + '/formpayhome/gateway/saveUserGateway';
export const UPDATE_GATEWAY_SETTING_API_URL =
  HOST_API + '/formpayhome/gateway/updateGatewaySettings';
export const DELETE_PORTAL_API_URL =
  HOST_API + '/formpayhome/portal/disconnectPortal';
export const FORMS_LISTING_API_URL =
  HOST_API + '/formpayhome/portal/getPortalForms';
export const TRANSACTION_LISTING_API_URL =
  HOST_API + '/formpayhome/portal/getTransactions';
export const FORM_CREATE_API_URL =
  HOST_API + '/formpayhome/portal/addPortalForm';
export const GET_PORTAL_FORM_API_URL =
  HOST_API + '/formpayhome/portal/getPortalForm/';
export const DELETE_PORTAL_FORM_API_URL =
  HOST_API + '/formpayhome/portal/deletePortalForm/';
export const UPDATE_PORTAL_FORM_API_URL =
  HOST_API + '/formpayhome/portal/updatePortalForm/';
export const GET_ALL_HUBSPOT_FORM_API_URL =
  HOST_API + '/formpayhome/portal/getHubspotForms';
export const FORM_SUBMISSION_LISTING_API_URL =
  HOST_API + '/formpayhome/portal/getFormSubmissions';
export const HUBSPOT_SEARCH_API_URL =
  HOST_API + '/formpayhome/product/searchHubProduct';
export const BILLING_DETAIL_API_URL =
  HOST_API + '/formpayhome/billing/getDetails';
export const BILLING_START_API_URL = HOST_API + '/formpayhome/billing/start';
export const BILLING_CONFIRM_PAYMENT_API_URL =
  HOST_API + '/formpayhome/billing/confirmCardPayment';
export const BILLING_CANCEL_SUBSCRIPTION_API_URL =
  HOST_API + '/formpayhome/billing/cancel';
export const DELETE_FORM_API_URL =
  HOST_API + '/formpayhome/portal/deletePortalForm/';
export const RAZORPAY_PLANS_URL =
  '/formpayhome/subscription/fetchRazorpayPlans';
export const EXISTING_HUBSPOT_PRODUCT_URL =
  HOST_API + '/formpayhome/product/fetchFormpayProduct';
export const CREATE_PRODUCT_URL =
  HOST_API + '/formpayhome/product/createFpProduct';
export const FETCH_HUBSPOT_PRODUCT =
  HOST_API + '/formpayhome/product/fetchHubspotProduct';
export const GET_FILTER_DATA_URL = '/formpayhome/admin/userDetail';
export const GET_SUBMISSION_GRAPH_URL = '/formpayhome/admin/submissionGraph';
export const GET_RAZORPAY_OAUTH =
  HOST_API + '/formpayhome/gateway/razorpauAuthUrl';
export const GET_STRIPE_OAUTH_URL =
  HOST_API + '/formpayhome/gateway/stripeAuthUrl';
export const SUBSCRIPTION_LISTING_API_URL =
  HOST_API + '/formpayhome/subscription/getPortalSubscription';
export const CANCEL_SUBSCRIPTION_API_URL =
  HOST_API + '/formpayhome/subscription/cancelStripeSubscription';
export const SEND_CANCEL_SUBSCRIPTION_MAIL =
  HOST_API + '/formpayhome/subscription/sendCancelSubscriptionEmail';
export const GET_XERO_AUTH_URL =
  HOST_API + '/formpayhome/integration/xeroAuthUrl';
export const GET_INTEGRATIONS_URL =
  HOST_API + '/formpayhome/integration/getUserIntegrations';
export const DISCONNECT_XERO_URL =
  HOST_API + '/formpayhome/integration/disconnectIntegration';
